import { render, staticRenderFns } from "./Index-FinancialMovements.vue?vue&type=template&id=0b80f426&"
import script from "./Index-FinancialMovements.vue?vue&type=script&lang=js&"
export * from "./Index-FinancialMovements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports